import React from 'react';
import { ICategory } from './categorypage/categorypage.d';
import { AtsTrackingHelper } from '../Common/atsTrackingHelper';

export default abstract class BaseComponent<P, S> extends React.Component<P, S> {
    constructor(props: P) {
        super(props);
    }

    componentDidMount(): void {
        const navigationKey = this.getCategory() ? this.getCategory().navigationKey : 'unknown category';

        AtsTrackingHelper.publishEvent({
            navigationKey: navigationKey
        });

    }

    private getCategory(): ICategory | undefined {
        return (this.props as { category?: ICategory }).category;
    }

    abstract render(): React.ReactNode;
}